import React from "react";
import TFLogin from "./TFLogin";
import LoginAnnouncement from "./LoginAnnouncement";
import "./LoginForm.css";

function LoginForm() {
  return (
    <div className="container-fluid">
      <div className="row login-header-row">
        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-5 mt-1">
          <div className="d-flex flex-column align-items-center mb-2">
            <img
              src="/assets/images/kig-e7Ti-vgY.png"
              alt="KIG"
              className="mx-auto"
            />
            <span className="text-white" style={{ fontSize: "0.75rem" }}>
              KRAJOWA IZBA GOSPODARCZA
            </span>
          </div>
        </div>
        <div className="col-12 col-lg login-message-column mt-1">
          <LoginAnnouncement />
        </div>
      </div>

      <div className="row g-0 align-items-stretch">
        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-5 p-0">
          <div className="bg-white login-card-left h-100 d-flex flex-column justify-content-between">
            <div>
              <h1 className="display-4 text-center mb-1">Logowanie</h1>
              <p className="text-muted text-center mb-2">
                Elektroniczne świadectwo pochodzenia
              </p>
              <TFLogin />
            </div>
          </div>
        </div>

        <div className="col p-0">
          <div className="login-card-right h-100 d-flex flex-column justify-content-between p-2 bg-light">
            <h2 className="h2 mb-2" style={{ color: "#1e3a8a" }}>
              Instrukcja rejestracji konta:
            </h2>

            <div className="flex-grow-1">
              <div className="d-flex align-items-start justify-content-center mb-0">
                <span
                  // className="me-1"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "48px",
                    color: "#0074cc",
                    fontWeight: 400,
                    lineHeight: 1,
                    marginRight: "1.8rem",
                  }}
                >
                  1
                </span>
                <p
                  className="mb-1"
                  style={{
                    fontSize: "1.3rem",
                    lineHeight: 1.3,
                    fontWeight: 500,
                  }}
                >
                  Wejdź na stronę{" "}
                  <a
                    href="https://co.kig.pl/Register"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#0d6efd" }}
                  >
                    https://co.kig.pl/Register
                  </a>
                  , wpisz swój adres e-mail, imię i nazwisko, a następnie
                  kliknij <strong>„Zarejestruj"</strong>.
                </p>
              </div>

              <div className="d-flex align-items-start justify-content-center mb-0">
                <span
                  className="me-1"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "48px",
                    color: "#0074cc",
                    fontWeight: 400,
                    lineHeight: 1,
                  }}
                >
                  2
                </span>
                <p
                  className="mb-1"
                  style={{
                    fontSize: "1.3rem",
                    lineHeight: 1.3,
                    fontWeight: 500,
                  }}
                >
                  Otrzymasz e-mail z prośbą o potwierdzenie rejestracji. Kliknij
                  przycisk <strong>„Aktywuj konto"</strong>, aby zakończyć
                  proces.{" "}
                  <strong>
                    Po aktywacji możesz już składać wnioski i pobierać
                    dokumenty.
                  </strong>
                </p>
              </div>

              <div className="d-flex align-items-start justify-content-center mb-0">
                <span
                  className="me-1"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "48px",
                    color: "#0074cc",
                    fontWeight: 400,
                    lineHeight: 1,
                  }}
                >
                  3
                </span>
                <p
                  className="mb-1"
                  style={{
                    fontSize: "1.3rem",
                    lineHeight: 1.3,
                    fontWeight: 500,
                  }}
                >
                  Aby się zalogować, przejdź na{" "}
                  <a
                    href="https://co.kig.pl"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#0d6efd" }}
                  >
                    https://co.kig.pl
                  </a>
                  . Wpisz adres e-mail użyty przy rejestracji – na ten adres
                  otrzymasz jednorazowe hasło logowania.
                </p>
              </div>

              <div className="d-flex align-items-start justify-content-center mb-0">
                <span
                  className="me-1"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "48px",
                    color: "#0074cc",
                    fontWeight: 400,
                    lineHeight: 1,
                  }}
                >
                  4
                </span>
                <p
                  className="mb-0"
                  style={{
                    fontSize: "1.3rem",
                    lineHeight: 1.3,
                    fontWeight: 500,
                  }}
                >
                  W ciągu 15 minut od otrzymania hasła użyj go do logowania.{" "}
                  <strong>
                    Nie musisz tworzyć ani zapamiętywać hasła – wystarczy dostęp
                    do skrzynki e-mail
                  </strong>
                  . Przy każdym logowaniu wyślemy Ci nowe, jednorazowe hasło.
                </p>
              </div>
            </div>

            <div
              className="text-end mt-2"
              style={{
                color: "#e728b1ff",
              }}
            >
              <p
                className="mb-0"
                style={{ fontWeight: 700, fontSize: "1.7rem" }}
              >
                ŚWIADECTWA POCHODZENIA
              </p>
              <p
                className="mb-0"
                style={{ fontWeight: 600, fontSize: "1.5rem" }}
              >
                Sprawdź więcej:{" "}
                <a
                  href="https://swiadectwapochodzenia.kig.pl"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#e728b1ff", fontWeight: 500 }}
                >
                  swiadectwapochodzenia.kig.pl
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-2 mb-2">
        <div className="col-12 col-md-12 col-lg-6 col-xl-5">
          <div className="d-flex flex-column text-white">
            <div className="d-flex justify-content-center">
              Krajowa Izba Gospodarcza | ul. Trębacka 4, 00-074 Warszawa
            </div>
            <div className="d-flex justify-content-center">
              NIP: 526 000 17 08 | Regon: 006210187
            </div>
            <div className="d-flex justify-content-center">
              e-mail:&nbsp;
              <a
                href="mailto:swiadectwapochodzenia@kig.pl"
                className="text-white"
              >
                swiadectwapochodzenia@kig.pl
              </a>
            </div>
          </div>
        </div>
        <div className="col d-none d-md-block"></div>
      </div>
    </div>
  );
}

export default LoginForm;
